/**
 * Created by lari on 08/06/2017.
 */
(function () {
  'use strict';
  angular.module('vcuser.vclogin')
    .component('loginform', {
      restrict: 'E',
      bindings: {
        dialog: '<',
        url: '<'
      },
      templateUrl: 'vcuser/vclogin/loginform-component.tpl.html',
      controllerAs: 'vm',
      controller: ['$log', '$http', '$cookies', '$window', '$state',
        function ($log, $http, $cookies, $window, $state) {
          let vm = this;
          vm.sendcreds = sendcreds;

          function sendcreds() {
            $http.post('/routes/login',
              {username: vm.login.username, password: vm.login.password})
                .then(function (user) {
                  $log.debug('user', user);
                  $cookies.put('username', vm.login.username);
                  $cookies.put('userfull', user.data.realName);
                  $cookies.put('userid', user.data._id);
                  $cookies.put('userroles', user.data.roles);
                  $log.debug('redirect url: ', vm.url);
                  $log.debug('dialog: ', vm.dialog);
                  vm.dialog.close();
                  if (angular.isDefined(vm.url) && angular.isString(vm.url) && vm.url.length > 0 && vm.url !== '/login') {
                    $log.debug('$window: ', $window.location);
                    $window.location.href = '#' + vm.url;
                    // $location.url(vm.url);
                    $window.location.reload();
                    //
                    $log.debug('after login redirect active $state.$current: ', $state.$current);
                    $state.go($state.$current, null, {reload: true});
                    // $state.go('home', null, {reload: true});
                  }
                  else {
                    $state.go('home', null, {reload: true});
                  }
                },
                function () {
                  $log.debug('login error');
                  vm.login.username = '';
                  vm.login.password = '';
                  vm.error = true;
                });
          }


        }] // controller
    }); // component

// klammerfriedhof
}());